import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'


// import { VueReCaptcha } from 'vue-recaptcha-v3'

// Vue.use(VueReCaptcha, { 
//   siteKey: '6LfactEZAAAAABKak2SnyHv5SlMMK8TyAWBLn9xb', 
//   loaderOptions: {
//     autoHideBadge: true
//   } 
// })


import 'overlayscrollbars/css/OverlayScrollbars.css';
import OverlayScrollbars from 'overlayscrollbars';
// import { OverlayScrollbarsPlugin } from 'overlayscrollbars-vue';
 
// Vue.use(OverlayScrollbarsPlugin);

import VueMeta from 'vue-meta'
// import {qrMap} from '@/utils.js'
// import axios from 'axios';

import { ApplicationInsights } from '@microsoft/applicationinsights-web'

// var appInsights = new ApplicationInsights({ config: {
//   instrumentationKey: process.env.VUE_APP_APPINSIGHTS_KEY,
//   autoTrackPageVisitTime: true,
//   enableAutoRouteTracking: true
// } });
// if(process.env.VUE_APP_APPINSIGHTS_KEY){
//   appInsights.loadAppInsights();
//   // appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
//   // TODO this might cause the double pageview I see in the data? :D
// }

// QR redirection stuff
// console.log(window.location)
// // const queryParams = new Proxy(new URLSearchParams(window.location.search), {
// //   get: (searchParams, prop) => searchParams.get(prop),
// // });
// // // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
// // let qr = queryParams.qr; // "some_value"
// if(window.location == 'h5'){
//   //appInsights.loadAppInsights()
//   //appInsights.trackTrace({message: `local testing: ig qr code redirect` })
//   // console.log('QR: ' + qr)
//   appInsights.trackEvent({name: "QR", properties: {code: 'ig'}})
//   appInsights.flush(false)   
//   console.log('here comes the redirect...')
//   //window.location.href = 'https://www.instagram.com/cityphography'; 
// }
// else{
  let externalRedirect = false
  // backward compatible qr code event generation before app load - outside the context of router (until my old stickers will be all destroyed lol)
  // if(window.location.hash){   
  //   let qr = qrMap.find(q => q.hash == window.location.hash) 
  //   if(qr){
  //     //appInsights.trackEvent({name: "QR", properties: {code: qr.id, target: 'ig'}})
  //     //appInsights.flush(false)
  //     externalRedirect = true
  //     //setTimeout(function(){window.location.replace('https://www.instagram.com/cityphography')}, 200)      
  //     let lofasz = [
  //       {
  //           "time": new Date().toISOString(),
  //           "iKey": process.env.VUE_APP_APPINSIGHTS_KEY,
  //           "name": "Microsoft.ApplicationInsights.b5fea834c5034b859fd6ed7419303c32.Event",        
  //           "data": {
  //               "baseType": "EventData",
  //               "baseData": {
  //                   "ver": 2,
  //                   "name": "QR",
  //                   "properties": {
  //                       "code": qr.id,
  //                       "target": "ig"
  //                   }
  //               }
  //           }
  //       }
  //     ]
  //     //console.log(lofasz)
  //     //appInsights.config.disableTelemetry = true
  //     // eslint-disable-next-line
  //     axios.post("https://dc.services.visualstudio.com/v2/track", lofasz).then(resp => {  
  //       console.log('redirecting to instagram')   
  //       window.location.replace('https://www.instagram.com/cityphography');   
  //     })
  //     .catch(err => {        
  //       console.error(err);
  //       window.location.replace('https://www.instagram.com/cityphography');
  //     }); 
      
  //     // window.location.replace('https://www.instagram.com/cityphography');
  //     // appInsights.config.disableTelemetry = true
  //     // throw new Error("REDIRECT");  // avoid useless loading of vue app and resources
  //   }
  // }

if(!externalRedirect){

  var appInsights = new ApplicationInsights({ config: {
    instrumentationKey: process.env.VUE_APP_APPINSIGHTS_KEY,
    autoTrackPageVisitTime: true,
    enableAutoRouteTracking: true
  } });
  if(process.env.VUE_APP_APPINSIGHTS_KEY){
    appInsights.loadAppInsights();
    if (typeof crypto.randomUUID === 'function'){
      let guid = crypto.randomUUID().replace(/[-]/g, '') // this is still not supported widely enough, on paper it is, but seen some people scanning with older safari browsers
      let telemetryInitializer = (envelope) => {
        envelope.tags["ai.operation.id"] = guid;  // because otherwise the operation id somehow differed for this call and subsequent AppInsights calls
      }
      appInsights.addTelemetryInitializer(telemetryInitializer);
    }
    // appInsights.trackPageView(); // Manually call trackPageView to establish the current user/session/pageview
    // TODO this might cause the double pageview I see in the data? :D
  }

  Vue.mixin({
    data: function() {
      return {
        appInsights: appInsights
      }
    }
  })

  Vue.prototype.$appInsights = appInsights

  OverlayScrollbars(document.body, {
    scrollbars: { 
      autoHide: 'scroll' 
    },
    nativeScrollbarsOverlaid: {
        initialize: false
    }
  });

  Vue.prototype.$hasMobileKeyboard = false

  Vue.config.productionTip = false;
  Vue.use(VueMeta);
  Vue.use(Vuex);

  const store = new Vuex.Store({
    state: {
      cartEnabled: false, //true,
      // hideMenu: false,
      theme: localStorage.getItem('theme'),
      cartFrameModel: JSON.parse(localStorage.getItem('cartFrameModel')) || undefined,
      cartFrameStyle: JSON.parse(localStorage.getItem('cartFrameStyle')) || undefined,
      pricePer: 5.9,
      basePrice: 17.0,
      shippingCountry: { name: 'Hungary', code: 'HU', price: 9.9 },
      inCartConfig: false
    },
    mutations: {
      setInCartConfigFlag(state, flag){
        state.inCartConfig = flag
      },
      setTheme(state, theme){
        localStorage.setItem('theme', theme)
        state.theme = theme
      },
      enableCart (state) {
        state.cartEnabled = true;
      },
      setCartFrameModel (state, {codesArray, styleConfig}){ 
        localStorage.setItem('cartFrameModel', JSON.stringify(codesArray));
        localStorage.setItem('cartFrameStyle', JSON.stringify(styleConfig));
        state.cartFrameModel = codesArray;
        state.cartFrameStyle = styleConfig;
        state.cartEnabled = true;
      },
      clearCartFrameModel (state){
        localStorage.removeItem('cartFrameModel');
        localStorage.removeItem('cartFrameStyle');
        state.cartFrameModel = null;
        state.cartFrameStyle = null;
      },
      setShippingCountry (state, country){
        state.shippingCountry = country;
      }
      //,
      // hideMenu (state){
      //   state.hideMenu = true;
      // },
      // showMenu (state){
      //   state.hideMenu = false;
      // }
    },
    getters: { 
      showCart: (state, getters) => state.cartEnabled || !getters.cartIsEmpty,   
      cartIsEmpty: state => {
        return !state.cartFrameModel || state.cartFrameModel.length == 0;
      },
      price: (state, getters) => {
        return Math.round(getters.cartIsEmpty ? 0 : (state.basePrice + state.cartFrameModel.length * state.pricePer)*100)/100
      },
      netPrice: (state, getters) => {
        return Math.round((getters.cartIsEmpty ? 0 : getters.price) / 1.27*100)/100;
      },
      tax: (state, getters) => {
        return Math.round((getters.cartIsEmpty ? 0 : getters.price) * 27/127*100)/100;
      },
      shippingNetPrice: (state) => Math.round(state.shippingCountry.price / 1.27*100)/100,
      shippingTax: (state) => Math.round(state.shippingCountry.price * 27/127*100)/100    
    }
  })

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}
//}
